import { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";

const DomesticMarketSpreadPriceContext = createContext();

const DomesticMarketSpreadPriceProvider = ({ children }) => {
  const [isFavoritesModal, setIsFavoritesModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("producer");

  const { data: favorites, isValidating: isFavoritesValidating } = useSWR(
    selectedTab === "producer"
      ? "/favorite/domestic-ratio/producer"
      : "/favorite/domestic-ratio/category",
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return (
    <DomesticMarketSpreadPriceContext.Provider
      value={{
        isFavoritesModal,
        setIsFavoritesModal,
        favorites,
        isFavoritesValidating,
        selectedTab,
        setSelectedTab,
      }}
    >
      {children}
    </DomesticMarketSpreadPriceContext.Provider>
  );
};

export default DomesticMarketSpreadPriceProvider;

export const useDomesticMarketSpreadPriceContext = () =>
  useContext(DomesticMarketSpreadPriceContext);
